// extracted by mini-css-extract-plugin
module.exports = {"note":"w2R5V8P2sCV1fpDvzwGyDA==","headerWrapper":"+cNFEkpf4jU5BWv5IFMxew==","gridContainer":"xDGyUwLJimygS1pOSbZb+g==","customColumn":"_0yCKmo6enmKD4AhqamLiUA=="};